import { useState, useCallback } from 'react';
import { useDeleteCompanyMutation } from '../services/companies.service';
import { useNotification } from '@/hooks';
import { getErrorMessage } from '@/utils';
import { NotificationSeverity } from '@/components/notifications/Notification';

export interface DeleteCompanyModalState {
  open: boolean;
  companyId: string;
  companyName: string;
}

const useDeleteCompanyModal = () => {
  const [deleteCompany, { isLoading: isDeleting }] = useDeleteCompanyMutation();
  const { showNotification } = useNotification();

  const [deleteModal, setDeleteModal] = useState<DeleteCompanyModalState>({
    open: false,
    companyId: '',
    companyName: '',
  });

  const openDeleteModal = useCallback((companyId: string, companyName: string) => {
    setDeleteModal({ open: true, companyId, companyName });
  }, []);

  const closeDeleteModal = useCallback(() => {
    if (!isDeleting) {
      setDeleteModal({ open: false, companyId: '', companyName: '' });
    }
  }, [isDeleting]);

  const handleConfirmDelete = useCallback(async () => {
    try {
      await deleteCompany(deleteModal.companyId).unwrap();
      showNotification('Compañía eliminada correctamente', NotificationSeverity.success);
      setDeleteModal({ open: false, companyId: '', companyName: '' });
    } catch (error) {
      const errorMessage = getErrorMessage(error, 'Error al eliminar la compañía');
      showNotification(errorMessage, NotificationSeverity.error);
    }
  }, [deleteModal.companyId, deleteCompany, showNotification]);

  return {
    deleteModal,
    openDeleteModal,
    closeDeleteModal,
    handleConfirmDelete,
    isDeleting,
  };
};

export default useDeleteCompanyModal;
